module.exports = __webpack_public_path__ + "img/service.ffe9450f.jpg";